import './CreatePostForm.sass';

import React, { useMemo } from 'react';
import { Input } from 'uikit';
import { useCurrentUserInfo, useGroupInfo, useTranslator } from '$hooks';
import { ModalLink, UnitPhoto } from '$shared/components';

export function CreatePostForm({ ownerId }: { ownerId: number }) {
  const user = useCurrentUserInfo();
  const group = useGroupInfo(-ownerId);
  const t = useTranslator();

  const info = useMemo(() => {
    if (ownerId < 0) {
      return {
        placeholder: t('create_post_form_placeholder_group'),
        photo: group.photo,
        route: `new_post${ownerId}`,
      };
    } else {
      return {
        placeholder: t('create_post_form_placeholder_user'),
        photo: user.photo,
        route: 'post',
      };
    }
  }, [user, group, ownerId, t]);

  return (
    <ModalLink name={info.route}>
      <div className="CreatePostForm">
        <UnitPhoto
          className="CreatePostForm__photo"
          onlineIndicator={false}
          nftIndicator={false}
          unit={user}
          size="small"
        />
        <Input placeholder={info.placeholder} />
      </div>
    </ModalLink>
  );
}
